import { DataPath } from '@repperjs/shared/src/@types/DataPath';
import { route } from '../../constants.ts';
import { CursorType } from '@repperjs/shared/src/@types/interaction/CursorType';
import { createAction } from '@reduxjs/toolkit';
import type { Vec2 } from '@repperjs/regl/@types/Vec2';

export const updateChunkDebug = createAction<{ path: DataPath; value: any }>(`${route}/UPDATE_CHUNK_DEBUG`);
export const updateShowCanvas = createAction<{ showCanvas: boolean; index: number }>(`${route}/UPDATE_SHOW_CANVAS`);

export const updateInteraction = createAction<{ trigger: any }>(`${route}/UPDATE_INTERACTION`);

export const updateMouse = createAction<{ path: DataPath; value: any }>(`${route}/UPDATE_MOUSE`);

export const updateLoadingState = createAction<{ renderSlotId: string; loading: boolean }>(
    `${route}/UPDATE_LOADING_STATE`,
);

/**
 * internal action for interaction sagas to stop double listening
 */
export const lockInteraction = createAction<{ drag: boolean; origin: string }>(`${route}/LOCK_INTERACTION`);

export const updateCursorType = createAction<{ cursorType: CursorType }>(`${route}/UPDATE_INTERACTION_CURSOR`);

export const updateEditorResolution = createAction<{ resolution: Vec2 }>(`${route}/UPDATE_EDITOR_RESOLUTION`);
